/**
 * `expo-splash-screen` (e o `SplashScreen` re-exportado pelo expo-router), no browser.
 *
 * O splash nativo é uma janela do SO; no web, o `index.html` pode trazer um `<div id="splash">`
 * estático (fundo #294956 + logo) visível antes do JS. `preventAutoHideAsync()` não tem o que
 * segurar (resolve `true`); `hideAsync()` some com o `#splash` (fade de 150 ms) — idempotente e
 * no-op se o elemento não existir.
 */
let escondido = false;

export async function preventAutoHideAsync(): Promise<boolean> {
  return !escondido;
}

export async function hideAsync(): Promise<void> {
  if (escondido || typeof document === "undefined") return;
  escondido = true;
  const el = document.getElementById("splash");
  if (!el) return;
  el.style.transition = "opacity 150ms ease-out";
  el.style.opacity = "0";
  el.style.pointerEvents = "none";
  await new Promise<void>((resolve) => setTimeout(resolve, 160));
  el.remove();
}

/** API nova do expo-splash-screen. */
export function hide(): void {
  void hideAsync();
}

export function setOptions(_opcoes: { duration?: number; fade?: boolean }): void {
  // WEB: o fade é fixo (150 ms).
}
